import { UserRole as EUserRole } from 'generated/graphql';
import { UserRole } from 'v2/core/entities/user';

export const MapToEdgeUserRole = (
  userRole?: UserRole,
): EUserRole | undefined => {
  switch (userRole) {
    case UserRole.ProductManagement:
      return EUserRole.ProductManagement;
    case UserRole.ProductOperation:
      return EUserRole.ProductOperation;
    case UserRole.UxResearch:
      return EUserRole.UxResearch;
    case UserRole.Founder:
      return EUserRole.Founder;
    case UserRole.UserResearch:
      return EUserRole.UserResearch;
    case UserRole.CustomerSupport:
      return EUserRole.CustomerSupport;
    case UserRole.Other:
      return EUserRole.Other;
    default:
      return undefined;
  }
};
